import React, { useEffect } from "react";
import { Card } from "antd";
import Filterbox from "../../ui/FilterBox/Filterbox";
import { serviceCategoriesColumn, servicesColumn } from "../../DummyAPI/TableData/Columns";
import { useDispatch, useSelector } from "react-redux";
import { listServices } from './../../redux/actions/service';
import ProgressLoader from "../../components/Loader/ProgressLoader";
import { selectServicesData, selectServicesLoading, selectServicesPagination } from './../../redux/selectors/serviceSelectors';
import SpPagination from "../../components/SpPagination/SpPagination";
import DataTable from "../../ui/DataTable/DataTable";

const AllServices = ({ type }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectServicesLoading)
  const serviceList = useSelector(selectServicesData);

  const servicesPagination = useSelector(selectServicesPagination);
    const { totalRecords, pageSize, currentPage } = servicesPagination || {};

  useEffect(() => {
    dispatch(listServices({ type }));
  }, [dispatch, type]);

  return (
    <ProgressLoader isLoading={isLoading}>
      <Card className="sapa-services__container">
        <Filterbox
          displayFilter={"none"}
          //filterType="Service"
          searchIsLoading={isLoading}
          searchAction={listServices}
          searchActionData={{
            type
          }}
          /* applyFilterAction={listServices}
          applyFilterActionData={{
            type
          }}
          exportFileName="services.csv"
          dataToExport={prepareDataToExport} */
          showExportButton={false}
        />

        <DataTable
          dataSource={serviceList}
          columns={type?.toLowerCase() === "services" ? serviceCategoriesColumn : servicesColumn}
          scrollX={860}
        />

        <SpPagination
          defaultCurrent={currentPage}
          total={totalRecords}
          pageSize={pageSize}
          onChange={(value) => {
            dispatch(listServices({ nextPage: value, type }));
          }}
        />
      </Card>
    </ProgressLoader>
  );
};

export default AllServices;
